<template>
    <Main>
        <el-row :gutter="20" class="search-table">
            <el-col :span="14" :xs="24" class="mb-2 mb-sm-0">
                <InputSearch v-model="keySearch" @keydown.enter="handleSearchData" @search="handleSearchData" :placeholder="$t('share.searchUserShare')"></InputSearch>
            </el-col>
            <el-col :span="5" :xs="24" v-if="isAccountAdmin" class="mb-2 mb-sm-0">
                <SelectCustom v-model="config.dataFilter['user_create_share']" :placeholder="$t('member.fullName')">
                    <template #options>
                        <el-option-group v-for="(company, indexC) in listMembers" :key="indexC + 'index'" :label="company.company">
                            <el-option v-for="user in company.options" :key="user.id" :label="`${user.surname} ${user.name}`" :value="user.id"> </el-option>
                        </el-option-group>
                    </template>
                </SelectCustom>
            </el-col>
        </el-row>
        <el-row :gutter="20" class="mt-2 mt-sm-3">
            <el-col :span="7" :xs="24" class="mb-sm-0 mb-2">
                <DateTimePicker
                    :date-time.sync="dateTime"
                    :placeholder-start="$t('msgCommon.placeholderCreatedAtStart')"
                    :placeholder-finish="$t('msgCommon.placeholderCreatedAtEnd')"
                ></DateTimePicker>
            </el-col>
            <el-col :span="7" :xs="24">
                <DateTimePicker
                    id-string="dateTimeUpdate"
                    id="dateTimeUpdate"
                    :date-time.sync="dateTimeUpdate"
                    :placeholder-start="$t('member.datePickerStartPlaceholder')"
                    :placeholder-finish="$t('member.datePickerEndPlaceholder')"
                ></DateTimePicker>
            </el-col>
        </el-row>
        <TableBox :config="config" :reload="isReload" :data-list.sync="dataList" @updateModel="updateModel" class="table-list-share">
            <template #row="{ row, index, page, perPage }">
                <tr :class="{ 'row-disabled': !row.enable }">
                    <td :data-title="$t('textCommon.no')">
                        <div class="col-first">
                            {{ index + 1 + (page - 1) * perPage }}
                        </div>
                    </td>
                    <td class="col-share-name" :data-title="$t('member.shareName')">
                        <div class="col-share-name__text">{{ row['link_name'] }}</div>
                    </td>
                    <td class="col-full-name" :data-title="$t('share.supplier')">
                        {{ row['user'] && row['user'].company_name }}
                    </td>
                    <td class="text-left col-created" :data-title="$t('member.updated_at')">
                        <FormatDate format="YYYY/MM/DD HH:mm:DD" :date="row.updated_at"></FormatDate>
                    </td>
                    <div class="d-flex justify-content-around flex-wrap fixed-right">
                        <Button classes="btn-xs mr-2" type="outline-primary" :disabled="!row.enable" @click="handleViewData(row)">
                            <el-icon class="el-icon-document"></el-icon>
                            {{ $t('button.detail') }}
                        </Button>
                    </div>
                    <td :data-title="''" class="col-action col-action__middle text-sm-center text-left fix-right_mb" :class="{ 'col-action__large': isAccountAdmin }">
                        <div class="d-flex justify-content-around flex-wrap">
                            <Button classes="btn-xs px-2 mr-2 mr-sm-0" type="outline-primary" :disabled="!row.enable" @click="handleViewData(row)">
                                <el-icon class="el-icon-document"></el-icon>
                                {{ $t('button.detail') }}
                            </Button>
                        </div>
                    </td>
                </tr>
            </template>
        </TableBox>
    </Main>
</template>

<script>
import Main from '@/components/partials/layout/Main';
import TableBox from '@/components/partials/layout/TableBox';
import InputSearch from '@/components/partials/customs/InputSearch';
import DateTimePicker from '@/components/partials/customs/DateTimePicker';
import Button from '@/components/partials/Button';
import { mapState } from 'vuex';
import FormatDate from '@/components/partials/FormatDate';
import SelectCustom from '@/components/partials/customs/SelectCustom';
import { groupByData } from '@/utils';
export default {
    name: 'ShareList',
    components: {
        FormatDate,
        TableBox,
        Main,
        InputSearch,
        DateTimePicker,
        Button,
        SelectCustom
    },
    data: function () {
        return {
            config: {
                q: '',
                action: 'connect/getListConnectOfMember',
                headers: [
                    {
                        label: 'textCommon.no'
                    },
                    {
                        sort: 'link_name',
                        label: 'share.shareName'
                    },
                    {
                        label: 'share.supplier'
                    },
                    {
                        sort: 'updated_at',
                        label: 'member.updated_at'
                    },
                    {
                        label: ''
                    }
                ],
                value: [1, 0],
                dataFilter: {
                    user_share: '',
                    start_updated_at: '',
                    end_updated_at: '',
                    start_created_at: '',
                    end_created_at: ''
                },
                sort: {
                    field: 'updated_at',
                    order: 'desc'
                }
            },
            isReload: false,
            keySearch: null,
            isLoading: false,
            dataList: [],
            dateTime: [],
            dateTimeUpdate: [],
            listMembers: []
        };
    },
    created() {
        let user = JSON.parse(localStorage.getItem('KB_DEV_CUSTOMER')) || null;
        if (user && user.type === 2) {
            this.getListAllMember();
        }
    },
    watch: {
        dateTime: {
            deep: true,
            handler: function (val) {
                this.config.dataFilter.start_created_at = val ? val[0] : '';
                this.config.dataFilter.end_created_at = val ? val[1] : '';
            }
        },
        dateTimeUpdate: {
            deep: true,
            handler: function (val) {
                this.config.dataFilter.start_updated_at = val ? val[0] : '';
                this.config.dataFilter.end_updated_at = val ? val[1] : '';
            }
        }
    },
    computed: {
        ...mapState('auth', ['userInfo']),
        isAccountAdmin() {
            if (localStorage.getItem('KB_DEV_CUSTOMER') || this.userInfo) {
                let user = JSON.parse(localStorage.getItem('KB_DEV_CUSTOMER')) || this.userInfo;
                if (user) {
                    let roleUser = parseInt(user.type);
                    return roleUser === 2;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        }
    },
    methods: {
        handleViewData(row) {
            this.$router.push({
                name: this.isAccountAdmin ? 'dataView' : 'dataViewChildren',
                query: {
                    id: row.id,
                    link_name: row['link_name']
                }
            });
        },

        getListAllMember() {
            let successCallback = (response) => {
                if (response.status) {
                    let { data } = response.data;
                    let listMemberGet = data.data_list || [];
                    listMemberGet = listMemberGet.filter((elm) => elm['parent_id']);
                    let listMemberByGroup = groupByData(listMemberGet, 'company_name');
                    this.listMembers = [];
                    if (listMemberByGroup) {
                        Object.keys(listMemberByGroup).map((key) => {
                            let item = {
                                company: key,
                                options: listMemberByGroup[key]
                            };
                            this.listMembers.push(item);
                        });
                    }
                }
            };
            let errorCallback = () => {};
            let payload = {
                successCallback,
                errorCallback
            };
            this.$store.dispatch('member/getListAllMembers', payload);
        },
        handleSearchData() {
            this.config.q = this.keySearch ? this.keySearch.toString().trim() : '';
            this.config = Object.assign({}, this.config);
        },
        updateModel(e) {
            this.config.dataFilter = Object.assign({}, e.dataFilter);
            this.dateTime[0] = e.dataFilter.start_created_at || '';
            this.dateTime[1] = e.dataFilter.end_created_at || '';
            this.dateTimeUpdate[0] = e.dataFilter.start_updated_at;
            this.dateTimeUpdate[1] = e.dataFilter.end_updated_at;
            this.config.q = e.search;
            this.keySearch = e.search;
        }
    }
};
</script>
